import { Component } from '@angular/core';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';

@Component({
  selector: 'app-chat-bot-asesor-v2-menu',
  templateUrl: './chat-bot-asesor-v2-menu.component.html',
})
export class ChatBotAsesorV2MenuComponent {

  overSuraIcon: boolean;

  constructor(
    public chatBotV2DS: ChatBotV2DataService,
  ) { }

  classTab: string = `w-full inline-flex flex-col gap-2 grow
    justify-center items-center self-stretch
    transition ease-in-out duration-200
    select-none cursor-pointer
    border-[#161618]
    hover:text-[#CCB613] hover:border-[#CCB613]
    lg:border-l-2 lg:border-b-0 border-l-0 border-b-2
    lg:pt-0 pt-2
  `;

  changeTab(index: number) {
    this.chatBotV2DS.tabActive.next(index);
  }

}
